import { IOrderSetup } from "./order-setup";
import { IEntityDto } from "./base";

export interface IArticle extends IEntityDto  {
  articleNumber?: string;
  internalNote?: string ;
  purchasingSetup?: IOrderSetup;
  description?: string;
  salesSetup?: IOrderSetup;
  groupId?: number;
  partnerSupplierContextId?: number;
  supplierId?: number;
  minimumStock?: number;
  maximumStock?: number;
  hasSerialNumber?: boolean;
  hasBatchNumber?: boolean;
  defaultLocationId?: number;
  priceProvider?: string;
  weight?: number;
  hasInventoryManagement?: boolean;
  salesPrice?: number;
  purchasePrice?: number;
  averageCostPrice?: number;
  hasVariants?: boolean;
  articleGroupDescription?: string;
  salesUnitAbbreviation?: string;
  purchasingUnitAbbreviation?: string;
  defaultLocationAbbreviation?: string;
  purchaseCurrencyAbbreviation?: string;
  salesCurrencyAbbreviation?: string;
  advancedSalesPrices?: boolean;
  advancedPurchasePrices?: boolean;
  isBundle?: boolean;
  supplierAccountNumber?: string;
  supplierName?: string;
  descriptionFriendly?: string;
}


